/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useImperativeHandle, useState } from 'react';
import type { SuggestionProps } from '@tiptap/suggestion';

const OptionList = (props: SuggestionProps<string, { id: string; label: string }>) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectItem = (index: number) => {
    const item = props.items[index];

    if (item) {
      props.command({ id: item, label: item });
    }
  };

  const upHandler = () => {
    setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
  };

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length);
  };

  const enterHandler = () => {
    selectItem(selectedIndex);
  };

  useEffect(() => setSelectedIndex(0), [props.items]);

  // eslint-disable-next-line react-hooks/refs
  useImperativeHandle((props as any).ref, () => ({
    onKeyDown: ({ event }: { event: any }) => {
      if (event.key === 'ArrowUp') {
        upHandler();
        return true;
      }

      if (event.key === 'ArrowDown') {
        downHandler();
        return true;
      }

      if (event.key === 'Enter') {
        enterHandler();
        return true;
      }

      return false;
    },
  }));

  return (
    <div className="bg-card border-foreground/10 z-50 flex min-w-[150px] flex-col items-center gap-1 rounded-lg border p-1 shadow-lg">
      {props.items.length ? (
        props.items.map((item, index) => (
          <button
            type="button"
            className={`hover:bg-ink-soft flex w-full cursor-pointer items-center gap-1 rounded-sm px-2 py-1 text-left ${
              index === selectedIndex ? 'bg-accent/10 text-accent' : 'text-ink'
            }`}
            key={index}
            onClick={() => selectItem(index)}
          >
            {item}
          </button>
        ))
      ) : (
        <div className="item">No result</div>
      )}
    </div>
  );
};

export default OptionList;
